import { ReactComponent } from "./file-upload-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const FileUploadLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default FileUploadLineIcon;
